import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './armazenamento/store';
import App from './App';
import './estilos/global.css';
import './estilos/admin.css';
import './estilos/responsivo.css';

/**
 * Ponto de entrada da aplicação NexoGourmet
 * Requisitos: 5, 6, 7, 10
 */

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
